import React, { useContext } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import TooltipButton from './child/TooltipButton';
import { LoginContext } from '../AuthContext/LoginContext'; // Adjust path

const Breadcrumb = ({ title, tooltipContent, linkTo, requiredPermission }) => {
  const { hasPermission } = useContext(LoginContext);

  if (requiredPermission && !hasPermission(requiredPermission.module, requiredPermission.action)) {
    return (
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
        <h6 className='fw-semibold mb-0'>{title}</h6>
      </div>
    );
  }

  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
      <h6 className='fw-semibold mb-0'>{title}</h6>
      
      <ul className='d-flex align-items-center gap-2'>
        <Link
          to={linkTo}
          className='d-flex align-items-center gap-1 hover-text-success'
        >
          <TooltipButton
            tooltipTitle=""
            tooltipContent={tooltipContent}
          >
            <button
              type='button'
              className='btn btn-success d-flex align-items-center px-1 py-1'
            >
              <Icon icon="mdi:plus" className="icon" style={{ fontSize: '30px' }} />
              <span className="text-white"></span>
            </button>
          </TooltipButton>
        </Link>
      </ul>
    </div>
  );
};

export default Breadcrumb;